import React, { useState, useEffect } from "react";
import pClasses from "./Profile.module.scss";
import Button from "@mui/material/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { withStyles } from "@mui/material/styles";
import { ChipTypeMap } from "@mui/material/Chip";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";

import {
  faArrowRight,
  faIdCard,
  faDumbbell,
  faFileAlt,
  faTrophy,
} from "@fortawesome/free-solid-svg-icons";
import { capitalizeAll } from "../../helpers/utilityHelper";
import { OverridableComponent } from "@mui/material/OverridableComponent";

const JourneyInfoCard = ({
  userInfos,
  setShowGraph,
  setSelectedJourney,
}: any = {}) => {
  const { t } = useTranslation();
  const { date_IA_start, date_IA_finish, status, journey } = userInfos ?? {};
  const [gotReports, setGotReports] = useState(false);
  useEffect(() => {
    if (status === -2 || status === -1) setGotReports(false);
    else setGotReports(true);
  }, [status]);
  const setJourney = (journey: any) => {
    setSelectedJourney(journey ? journey : 1);
  };
  const statusObj: any = {
    "-2": {
      title: "precadastro",
      icon: faIdCard,
      color: "#007085",
    },
    "-1": {
      title: "cadastro",
      icon: faIdCard,
      color: "#007085",
    },
    "0": {
      title: "avaliacao",
      icon: faDumbbell,
      color: "#7418A5",
    },
    "1": {
      title: "treino",
      icon: faDumbbell,
      color: "#003039",
    },
    "2": {
      title: "reavaliacao",
      icon: faFileAlt,
      color: "#7418A5",
    },
    "3": {
      title: "fimjornada",
      icon: faTrophy,
      color: "#469762",
    },
    "4": {
      title: "treino",
      icon: faDumbbell,
      color: "#003039",
    },
  };
  function createChip(renderVal: any) {
    const StyledChip = styled(Chip)(({ theme }) => ({
      root: {
        color: renderVal?.color,
        borderColor: renderVal?.color,
        fontWeight: 500,
      },
      icon: {
        color: renderVal?.color,
      },
    }));

    return (
      <StyledChip
        variant="outlined"
        label={t("global." + renderVal?.title)}
        icon={<FontAwesomeIcon icon={renderVal?.icon} />}
      />
    );
  }
  const yearStart = date_IA_start?.split("-")[0];
  const monthStart = date_IA_start?.split("-")[1];
  const dayStart = date_IA_start?.split("-")[2];
  const yearFinish = date_IA_finish?.split("-")[0];
  const monthFinish = date_IA_finish?.split("-")[1];
  const dayFinish = date_IA_finish?.split("-")[2];
  return (
    <div className={pClasses.JourneyInfoCard}>
      <div className={pClasses.Trophy}>
        {
          <FontAwesomeIcon
            color={
              statusObj[status]?.title === "fimjornada" ? "#007085" : "#8d8d8d"
            }
            fixedWidth={true}
            size={"5x"}
            icon={faTrophy}
            style={{
              padding: "10px",
              backgroundColor:
                statusObj[status]?.title === "fimjornada"
                  ? "#e5f1f5"
                  : "#ebebeb",
              borderRadius: "5px",
            }}
          />
        }
      </div>
      <div className={pClasses.initEndBox}>
        <h4>{capitalizeAll(t("global.start"))}</h4>{" "}
        <p>
        {date_IA_start ? `${dayStart}/${monthStart}/${yearStart}` : <>-</>}
        </p>
      </div>
      <div className={pClasses.initEndBox}>
        <h4>{capitalizeAll(t("global.end"))}</h4>{" "}
        <p>
          {date_IA_finish ? `${dayFinish}/${monthFinish}/${yearFinish}` : <>-</>}
        </p>
      </div>
      <div className={pClasses.statusInfoArea}>
        {createChip(statusObj[status])}
      </div>
      <div className={pClasses.PorileReportsButtonArea}>
        <Button
          disabled={!gotReports}
          onClick={() => {
            setShowGraph(true);
            setJourney(String(journey));
          }}
          style={{
            backgroundColor: "rgba(255, 0, 0, 0)",
            color: gotReports ? "#2F80ED" : "gray",
          }}
        >
          {t("global.access_reports")} {(" ‎ ")}<FontAwesomeIcon icon={faArrowRight} />
        </Button>
      </div>
    </div>
  );
};

export default JourneyInfoCard;
function customStyled(Chip: OverridableComponent<ChipTypeMap<object, "div">>) {
  throw new Error("Function not implemented.");
}

